import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from "@angular/core";

export interface RadioButtonListItem {
  display:String,
  isChecked:boolean,
  data?:any,
  isNested:boolean,
  isPrimary:boolean,
  isRollup:boolean
}

@Component({
  standalone: false,
  selector: "radiobutton-list",
  templateUrl: "./radiobutton-list.component.html",
  styleUrls: ["./radiobutton-list.component.scss"]
})
export class RadioButtonListComponent implements OnInit {

  @Input() items:RadioButtonListItem[];

  @Output() itemChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(private readonly el: ElementRef<HTMLElement>) { }

  ngOnInit() {
  }

  // Up/Down (plus Home/End) arrow navigation for the parameter list. The radios
  // carry unique ids but no shared `name`, so the browser's native radiogroup
  // arrow navigation never engages; a vertical option list is still expected to
  // move focus with the arrow keys (WAI-ARIA list pattern / WCAG 2.1.1
  // Keyboard). This moves focus to the previous/next row's radio (clamped at the
  // ends, no wrap) without altering the existing click-to-select behaviour.
  onListKeydown(event: KeyboardEvent) {
    const key = event.key;
    if (key !== "ArrowDown" && key !== "ArrowUp" && key !== "Home" && key !== "End") {
      return;
    }

    const rows = Array.from(
      this.el.nativeElement.querySelectorAll<HTMLElement>(".radiobutton-list-item")
    );
    if (rows.length === 0) {
      return;
    }

    const activeRow = (document.activeElement as HTMLElement | null)?.closest(".radiobutton-list-item") ?? null;
    const currentIndex = activeRow ? rows.indexOf(activeRow as HTMLElement) : -1;

    let nextIndex: number;
    switch (key) {
      case "ArrowDown":
        nextIndex = currentIndex < 0 ? 0 : Math.min(currentIndex + 1, rows.length - 1);
        break;
      case "ArrowUp":
        nextIndex = currentIndex < 0 ? 0 : Math.max(currentIndex - 1, 0);
        break;
      case "Home":
        nextIndex = 0;
        break;
      default: // "End"
        nextIndex = rows.length - 1;
        break;
    }

    const target = rows[nextIndex]?.querySelector<HTMLInputElement>('input[type="radio"]');
    if (target) {
      event.preventDefault();
      target.focus();
    }
  }


  handleClick($event,clickedItem){
    this.items.forEach((item)=>{
      let oldState = item.isChecked;
      item.isChecked = item === clickedItem;
      if(oldState!=item.isChecked){
        this.itemChanged.emit(item);
      }
    })

  }

  handlePrimary($event,item){
    $event.stopPropagation();
    item.isPrimary=!item.isPrimary
    this.itemChanged.emit(item);
  }
}
